var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26582 3.00003H13.7341C13.4845 1.96719 12.5541 1.2 11.4446 1.2H8.55534C7.4458 1.2 6.51545 1.96719 6.26582 3.00003ZM14.9569 3.00003H17.4899H17.5087H19.4C19.7314 3.00003 20 3.26866 20 3.60003C20 3.9314 19.7314 4.20003 19.4 4.20003H18.0423L16.8977 15.4933C16.6958 17.4847 15.0192 19 13.0175 19H6.98244C4.9808 19 3.30415 17.4847 3.10232 15.4933L1.95773 4.20003H0.6C0.268629 4.20003 0 3.9314 0 3.60003C0 3.26866 0.268629 3.00003 0.6 3.00003H2.4913H2.51013H5.04309C5.30971 1.30023 6.78068 0 8.55534 0H11.4446C13.2193 0 14.6902 1.30023 14.9569 3.00003ZM4.2962 15.3723L3.16388 4.20003H16.8361L15.7038 15.3723C15.5641 16.7509 14.4033 17.8 13.0175 17.8H6.98244C5.59669 17.8 4.43593 16.7509 4.2962 15.3723ZM7.34876 6.80219C7.67892 6.77389 7.96951 7.01859 7.99781 7.34875L8.59781 14.3488C8.62611 14.6789 8.3814 14.9695 8.05124 14.9978C7.72108 15.0261 7.43049 14.7814 7.40219 14.4512L6.80219 7.45123C6.77389 7.12107 7.0186 6.83049 7.34876 6.80219ZM13.1978 7.45123C13.2261 7.12107 12.9814 6.83049 12.6512 6.80219C12.3211 6.77389 12.0305 7.01859 12.0022 7.34875L11.4022 14.3488C11.3739 14.6789 11.6186 14.9695 11.9488 14.9978C12.2789 15.0261 12.5695 14.7814 12.5978 14.4512L13.1978 7.45123Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.30fcedb8a41a9f173f7345029434aa9d.svg";
export { ForwardRef as ReactComponent };